import Vue from 'vue';
import OfertaDialog from '@/modules/ofertas/oferta/OfertaDialog.vue';
import OfertaCard from '@/modules/ofertas/OfertaCard.vue';

Vue.component('pxOfertaDialog', OfertaDialog);
Vue.component('pxOfertaCard', OfertaCard);
